<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorPrice ? 'has-error' : ''">
      <label>Số tiền thanh toán<span class="error-symbol"></span></label>
      <currency-input v-model="oneTimePayment.price" @input="calculateLeftOver()" placeholder="Nhập số tiền thanh toán ..."/>
    </div>
    <div class="form-group col-md-12 col-sm-12 col-xs-12">
      <label>Phương thức thanh toán</label>
      <multiselect v-model="oneTimePayment.paymentMethod" :options="paymentMethods" :multiple="false"
                   :close-on-select="true"
                   placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
    </div>
    <div class="form-group col-md-12 col-sm-12 col-xs-12">
      <label>Ghi chú</label>
      <textarea
        class="form-control"
        id="textarea1"
        v-model="oneTimePayment.note"
        rows="3"
        style="height: 71px!important;"
      ></textarea>
    </div>
    <div class="form-group col-md-12 col-sm-12 col-xs-12">
      <label>Số hoá đơn</label>
      <input type="text" class="form-control" v-model="oneTimePayment.invoiceNo" placeholder="Nhập số hoá đơn..."/>
    </div>
    <div class="form-group col-md-12 col-sm-12 col-xs-12">
      <label>Số tiền còn thừa tạm tính:{{' '}}</label>
      <span>{{moneyLeftover | format_currency}}{{' '}}vnđ</span>
    </div>
    <div class="form-group col-md-12 col-sm-12 col-xs-12">
      <label>Sản phẩm</label>
      <vue-tags-input
        class="w-100"
        style="max-width: 100%!important;"
        v-model="tag"
        :tags="tags"
        placeholder=""
        @tags-changed="newTags => tags = newTags"
        :avoid-adding-duplicates="false"
        :disabled="true"
        :is-duplicate="isDuplicateTag"
      >
        <div slot="tag-actions"></div>
      </vue-tags-input>
    </div>

    <div class="form-group col-md-12 col-sm-12 col-xs-12">
      <label>Chọn sản phẩm</label>
    </div>
    <div class="form-group col-md-12 col-sm-12 col-xs-12">
      <input type="checkbox" id="checkbox" v-model="selectAll" @change="checkSelectAll($event)"/>
      <span>Chọn tất cả</span>
      <OrderDetailPaymentList class="mt-2" :updatingOrderId="orderId"
                              :updateSelectedOrderDetail="updateSelectedOrderDetail"
                              :disableSelection.sync="selectAll"
                              :type="type" :initOrderDetailId="initOrderDetailId"></OrderDetailPaymentList>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="pull-right mt-3">
        <b-button variant="success" class="w-150px" @click="saveOneTimePayment" :disabled="saving">Thanh toán</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentApi from '../../api/payment'
import Utils from '../../common/utils'
import {mapGetters} from 'vuex'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import {isNumber} from 'lodash'
import VueTagsInput from '@johmun/vue-tags-input'
import OrderDetailPaymentList from '../order_management/OrderDetailPaymentList'
import {eventBus} from '../../main'

export default {
  name: 'OneTimePayment',
  components: {
    Multiselect,
    VueTagsInput,
    OrderDetailPaymentList
  },
  props: {
    orderId: {
      type: Number,
      required: false
    },
    payment: {
      type: Object,
      required: false,
      default: null
    },
    order: {
      type: Object,
      required: false
    },
    type: {
      type: String,
      default: 'NEW_BUY'
    },
    initOrderDetailId: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      company: null,
      click: false,
      loading: false,
      saving: false,
      tag: '',
      tags: [],
      selectedOrderDetail: new Map(),
      selectAll: false,
      moneyLeftover: 0,
      oneTimePayment: {
        price: 0,
        paymentMethod: {text: 'Chuyển khoản', value: 'TRANSFER'},
        note: null,
        invoiceNo: null
      },
      paymentMethods: [
        {text: 'Tiền mặt', value: 'CASH'},
        {text: 'Thẻ', value: 'CARD'},
        {text: 'Chuyển khoản', value: 'TRANSFER'}
      ]
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    errorPrice () {
      return (!isNumber(this.oneTimePayment.price) || this.oneTimePayment.price <= 0) && this.click
    },
  },
  watch: {
    initOrderDetailId: {
      handler: function () {
        console.log('initOrderDetailId changed')
      }
    }
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    if (this.payment) {
      this.oneTimePayment.price = this.payment.value
      this.oneTimePayment.note = this.payment.sale_note
      this.oneTimePayment.invoiceNo = this.payment.invoice_no
      this.oneTimePayment.paymentMethod = this.getPaymentMethodObject(this.payment.payment_method)
    }
  },
  getPaymentMethodObject (value) {
    if (value === 'CASH') {
      return {text: 'Tiền mặt', value: 'CASH'}
    }
    if (value === 'CARD') {
      return {text: 'Thẻ', value: 'CARD'}
    }
    return {text: 'Chuyển khoản', value: 'TRANSFER'}
  },
  methods: {
    updateSelectedOrderDetail (selectedOrderDetail) {
      this.selectedOrderDetail = selectedOrderDetail
      this.tags = []
      for (let value of this.selectedOrderDetail.values()) {
        this.tags.push({'text': value.product.name + ': ' + value.quantity.toString(), 'tiClasses': ['ti-valid'], ...value})
      }
      this.calculateLeftOver()
    },
    getOrderDetailList () {
      if (this.selectAll) {
        return [0]
      } else {
        return Array.from(this.selectedOrderDetail.values()).map(item => item.id)
      }
    },
    saveOneTimePayment () {
      this.click = true
      if (this.errorPrice) {
        Utils.failedToast(this.$bvToast, 'Thanh toán', 'Số tiền thanh toán phải lớn hơn 0')
        return
      }
      this.saving = true
      this.loading = true

      let payment = {
        company_id: this.company.id,
        order_id: this.orderId,
        type: this.type,
        value: this.oneTimePayment.price,
        payment_method: this.oneTimePayment.paymentMethod.value,
        sale_note: this.oneTimePayment.note,
        invoice_no: this.oneTimePayment.invoiceNo,
        order_detail_list: this.getOrderDetailList()
      }

      if (this.payment === null) {
        PaymentApi.create(payment).then(res => {
          this.saving = false
          this.loading = false
          this.$bvModal.hide('oneTimePaymentModal')
          Utils.successToast(this.$bvToast)
          eventBus.$emit('orderDetailChanged')
        }).catch(err => {
          this.saving = false
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        payment = {id: this.payment.id, ...payment}
        PaymentApi.update(payment).then(res => {
          this.saving = false
          this.loading = false
          this.$bvModal.hide('oneTimePaymentModal')
          Utils.successToast(this.$bvToast)
        }).catch(err => {
          this.saving = false
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    isDuplicateTag (tags, tag) {
      return false
    },
    checkSelectAll () {
      this.selectedOrderDetail.clear()
      if (this.selectAll) {
        this.tags = [{'text': 'Tất cả', 'tiClasses': ['ti-valid'], 'id': 0}]
      } else {
        this.tags = []
      }
      this.calculateLeftOver()
    },
    calculateLeftOver () {
      this.moneyLeftover = this.oneTimePayment.price
      if (this.selectAll) {
        this.moneyLeftover -= this.order.debt
      } else {
        for (let value of this.selectedOrderDetail.values()) {
          this.moneyLeftover -= value.debt
        }
      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order_management/OneTimePayment.vue